export default __webpack_public_path__ + "static/media/07__o_1.8237b66e.jpg";